import React from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';

import Link from '@atlaskit/link/link';

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */

// The following eslint disables were added for the visual refresh 2025 effort. Thread with further details on why this was done can be found here: https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/97563/overview#comment-580291985
/* eslint-disable @atlaskit/design-system/use-heading */
/* eslint-disable @atlaskit/design-system/use-primitives-text */
/* eslint-disable @atlaskit/design-system/use-tokens-typography */

import messages from './messages.json';
import { i18n } from './errorAppi18n.ts';
import somethingWentWrongSvg from './something-went-wrong.svg';
import atlassianLogo from './atlassianLogo.svg';

export const SomethingWentWrong = (): React.JSX.Element => {
	const DEFAULT_LOCALE = 'en-US';
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	const locale = navigator.languages[0] || navigator.language || DEFAULT_LOCALE;

	return (
		<IntlProvider locale={locale} messages={messages as any} defaultLocale="en-US">
			<div
				style={{
					padding: '19px',
					background: '#F4F5F7',
					margin: '0',
				}}
			>
				<Link href="https://www.atlassian.com">
					{/* Since this is just our company name, it doesn't have to be translated. */}
					{/* eslint-disable-next-line no-restricted-syntax */}
					<img alt="Atlassian" src={atlassianLogo} style={{ width: '145px', height: '18px' }} />
				</Link>
			</div>
			<div
				style={{
					background: '#fff',
					padding: '60px 0',
					textAlign: 'center',
				}}
			>
				<img
					src={somethingWentWrongSvg}
					alt=""
					style={{ marginLeft: -20, width: '380px', height: '246px' }}
				/>
				<h1
					style={{
						color: '#253858',
						font: 'bold 36px Helvetica, Arial',
						marginTop: '50px',
						marginBottom: '24px',
					}}
				>
					<FormattedMessage {...i18n.title} />
				</h1>
				<h2
					style={{
						color: '#253858',
						font: 'bold 20px Helvetica, Arial',
						margin: '16px 0px',
					}}
				>
					<FormattedMessage {...i18n.subTitle} />
				</h2>
				<p
					style={{
						color: '#42526E',
						font: 'normal 20px/28px Helvetica, Arial',
						margin: '20px 0',
					}}
				>
					<FormattedMessage
						{...i18n.detail}
						values={{
							link: (
								// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
								<a
									target="_blank"
									id="statusPageHref"
									href="https://status.atlassian.com"
									style={{ textDecoration: 'underline' }}
								>
									<FormattedMessage {...i18n.linkName} />
								</a>
							),
						}}
					/>
				</p>
			</div>
		</IntlProvider>
	);
};
